import { TeamResultListTable } from './components/team-result-list-table';
import { divisionIdParamSchema, teamIdParamSchema } from '~/schemas';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Breadcrumb } from '~/components/Breadcrumb/Breadcrumb';
import { useDivisionDetailQuery } from '../divisions/queries';
import { useAuthentication } from '~/hooks/useAuthentication';
import { Button } from '~/components/Button/Button';
import { insertOnCondition } from '~/utils/array';
import { useTeamsQuery } from '../teams/queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  const { can } = useAuthentication();
  const { teamId } = useParams(teamIdParamSchema.parse);
  const { divisionId } = useParams(divisionIdParamSchema.parse);
  const { data, isLoading } = useTeamsQuery(teamId);
  const { data: division } = useDivisionDetailQuery(divisionId);
  if (!data || !division) return false;

  const rounds = division.rounds;

  const isBenchCompetition =
    division.series.competition_type.name === 'CBP' ||
    division.series.competition_type.name === 'PBP' ||
    division.series.competition_type.name === 'EBP';

  return (
    <Fragment>
      <PageLayout.Header>
        <div>
          <Breadcrumb>
            <Breadcrumb.Link to="/series/divisions">Serier</Breadcrumb.Link>
            <Breadcrumb.Link to={`/series/divisions/${division.id}`}>
              {data.division.name} - {data.division.series.name}
            </Breadcrumb.Link>
            <Breadcrumb.Current>Omgångsresultat - {data.name}</Breadcrumb.Current>
          </Breadcrumb>
          <PageLayout.Heading text={`Omgångsresultat - ${data.name}`} />
        </div>

        {rounds.length > 1 && (
          <Button.Group neutral>
            <PageLayout.Context
              items={[
                ...insertOnCondition(
                  <ContextMenu.Item label="Hantera resultat" to={`manage/rounds/${rounds[0].id}`} key="manage" />,
                  can('manage-round-result', data.club.id)
                ),
              ]}
            />
          </Button.Group>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        {data.round_results.map(results => (
          <Fragment key={results.id}>
            <PageLayout.SubHeading>{String(results.round.name)}</PageLayout.SubHeading>
            <TeamResultListTable
              results={results.results}
              isLoading={isLoading}
              isBenchCompetition={isBenchCompetition}
            />
          </Fragment>
        ))}
      </PageLayout.Section>
    </Fragment>
  );
}
